import { createApiRef } from '@backstage/frontend-plugin-api';
import { DefaultApiResponse } from '@internal/backstage-plugin-devops-react';

export type AccountResourceTypeMenuStatistic = {
  type: string;
  resourcesCount: number;
  /**
   * Background color generated from the type name by the backend. Optional
   * because older cached responses may not include it.
   */
  color?: string;
};

export type AccountServiceMenu = {
  service: string;
  resourcesCount: number;
  types: AccountResourceTypeMenuStatistic[];
};

export type AccountCloudResourcesMenu = {
  accountId: string;
  services: AccountServiceMenu[];
};

export const cloudResourcesMenuApiRef =
  createApiRef<CloudResourcesMenuApi>().with({
    id: 'cloud-resources-menu-api',
    pluginId: 'catalog-devops',
  });

export interface CloudResourcesMenuApi {
  getAccountCloudResourcesMenu(accountId: string): Promise<DefaultApiResponse>;
}
